export const MLDRIVEN_ITEMS_PAGE_SIZE_BUFFER = 3;

export const MLDRIVEN_ITEMS_ALGORITHM_TYPE = {
    TRENDING: "trending",
    RECOMMENDED: "recommended",
};

export const MLDRIVEN_ITEMS_TYPE = {
    SHORT_FORM_VIDEO: "short-form-video",
    ALL_ARTICLES: "all-articles",
    VIDEO_DISCOVERY_START: "video-discovery-start",
};

export const MLDRIVEN_ITEMS_TYPE_VIDEO = "video";
